define('components/asset-player/models/media-file-types',[], function () {
    "use strict";

    var MediaFileTypes = {
            "Type": {},
            "TypeExtensions": {}
        },
        Types;

    Types = [
        {
            "id": -1,
            "type": "UPLOADED_FILES",
            "extensions": ["*"]
        },

        {
            "id": 1,
            "type": "256K_WMV",
            "extensions": ["asf", "wmv"]
        },
        {
            "id": 2,
            "type": "256K_MOV",
            "extensions": ["mov"]
        },
        {
            "id": 3,
            "type": "MPG",
            "extensions": ["mpg"]
        },

        {
            "id": 6,
            "type": "TEACHERS_GUIDE",
            "extensions": ["pdf"]
        },
        {
            "id": 7,
            "type": "GENERAL_DOCUMENTS",
            "extensions": ["doc"]
        },
        {
            "id": 8,
            "type": "GENERAL_PDFS",
            "extensions": ["pdf"]
        },
        {
            "id": 9,
            "type": "GENERAL_IMAGES",
            "extensions": ["gif", "jpg", "png"]
        },

        {
            "id": 11,
            "type": "700K_WMV",
            "extensions": ["asf", "wmv"]
        },
        {
            "id": 12,
            "type": "256K_DRM",
            "extensions": ["asf", "wmv"]
        },
        {
            "id": 13,
            "type": "700K_DRM",
            "extensions": ["asf", "wmv"]
        },
        {
            "id": 14,
            "type": "CLOSED_CAPTION_FILE",
            "extensions": ["smi"]
        },

        {
            "id": 16,
            "type": "MP3",
            "extensions": ["mp3"]
        },
        {
            "id": 17,
            "type": "INTERACTIVE_FILES",
            "extensions": ["swf"]
        },

        {
            "id": 20,
            "type": "PDF_THAT_IS_NOT_A_RELATED_ITEM",
            "extensions": ["pdf"]
        },
        {
            "id": 21,
            "type": "WORD_DOCUMENT",
            "extensions": ["doc"]
        },
        {
            "id": 22,
            "type": "1MB_WMV",
            "extensions": ["asf", "wmv"]
        },
        {
            "id": 23,
            "type": "1MB_MOV",
            "extensions": ["mov"]
        },
        {
            "id": 24,
            "type": "600K_FLV",
            "extensions": ["flv"]
        },

        {
            "id": 31,
            "type": "POWER_POINT_PRESENTATION",
            "extensions": ["ppt"]
        },
        {
            "id": 32,
            "type": "HYPER_TEXT_MARKUP_LANGUAGE",
            "extensions": ["htm", "html"]
        },
        {
            "id": 33,
            "type": "MPEG",
            "extensions": ["mpg"]
        },
        {
            "id": 34,
            "type": "300K_MP4",
            "extensions": ["3gp", "m4v", "mp4"]
        },
        {
            "id": 35,
            "type": "2MB_MP4",
            "extensions": ["3gp", "m4v", "mp4"]
        },
        {
            "id": 36,
            "type": "SMALL_IMAGES",
            "extensions": ["gif", "jpg", "png"]
        },
        {
            "id": 37,
            "type": "MEDIUM_IMAGES",
            "extensions": ["gif", "jpg", "png"]
        },
        {
            "id": 38,
            "type": "LARGE_IMAGES",
            "extensions": ["gif", "jpg", "png"]
        },
        {
            "id": 39,
            "type": "EXCEL_WORK_SHEET",
            "extensions": ["xls"]
        },
        {
            "id": 40,
            "type": "CORRELATION_DOCUMENT",
            "extensions": ["pdf"]
        },
        {
            "id": 41,
            "type": "300K_OGG",
            "extensions": ["ogv"]
        },
        {
            "id": 42,
            "type": "400K_WEBM",
            "extensions": ["webm"]
        },
        {
            "id": 43,
            "type": "HYPER_TEXT_MARKUP_LANGUAGE_5",
            "extensions": ["htm", "html"]
        },
        {
            "id": 44,
            "type": "MAP_IMAGE_BASE",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 45,
            "type": "MAP_IMAGE_OVERLAY",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 46,
            "type": "SERVER_SIDE_SCRIPTS",
            "extensions": ["asp", "aspx", "cfm"]
        },
        {
            "id": 47,
            "type": "MOBILE_CARD_HANDHELD",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 48,
            "type": "MOBILE_CARD_TABLET",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 49,
            "type": "MOBILE_BANNER_HANDHELD",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 50,
            "type": "MOBILE_BANNER_TABLET",
            "extensions": ["jpg", "png"]
        },
        {
            "id": 51,
            "type": "PDF_VERSION",
            "extensions": ["pdf"]
        },
        {
            "id": 52,
            "type": "WEB_VTT",
            "extensions": ["vtt"]
        }
    ];

    _.each(Types, function (typeObject) {
        MediaFileTypes.Type[typeObject.type] = typeObject.id;
        MediaFileTypes.TypeExtensions[typeObject.type] = typeObject.extensions;
    });

    return MediaFileTypes;
});

